import "appdevresources/twig.jquery";
import * as autoComplete from "searchautocomplete/search-autocomplete";

$(async function () {
    const searchForm = $("[name='search-form']");
    const selectedPidm = searchForm.find("[name='selected-pidm']").first();
    const selectedProgram = searchForm.find("[name='selected-program']").first();
    const selectedAward = searchForm.find("[name='selected-award']").first();
    let prevSearchBy = $("#previous-search-by").val();
    let prevSearchId = $("#previous-search-id").val();
    let prevSearchName = $("#previous-search-name").val();
    const twig = $.twig();
    const siteContext = twig.get("siteContext");

    const studentsSearchList = twig.get("studentsSearchListArr");
    const programsSearchList = twig.get("programsSearchListArr");
    const awardsSearchList = twig.get("awardsSearchListArr");
    if (typeof studentsSearchList === undefined) {
        return;
    }

    $("#search-type").on("change",function () {
        prevSearchName = prevSearchId = prevSearchBy = "";
        selectedAward.val("");
        selectedProgram.val("");
        selectedPidm.val("");
        setSearchTypePlaceholder();
    });

    setSearchTypePlaceholder(true);

    function setSearchTypePlaceholder(onload = false) {
        if (prevSearchBy !== "") {
            $(`#search-type option[data-searchby="${prevSearchBy}"]`).prop("selected", true);
        }
        var placeholderText = $("#search-type option:selected").data("placeholder");
        var searchBy = $("#search-type option:selected").data("searchby");
        $("#nav-search").attr("placeholder", placeholderText).val("");
        $("#search-by").val(searchBy);
        $("#nav-search").val(prevSearchName !== "" ? prevSearchName : "");

        if ($("#nav-search.ui-autocomplete-input").length > 0) {
            $("#nav-search").autocomplete("destroy");
            $("#nav-search").removeData("sac-initialized");
        }

        let autofocus = false;
        switch (searchBy) {
            case "STUDENT":
                autoComplete.load(searchForm, studentsSearchList, {
                    autofocus: false,
                    searchClass: ".nav-search",
                    showExpandedResults: true,
                    submitOnSelect: true,
                    studentProfileRoute: "student_profile",
                    additionalStudentProfileRouteParameters: {siteContext: siteContext},
                    minLength: 4});
                prevSearchName !== "" ? $("#selected-pidm").val(prevSearchId) : "";
                $("#search-button").show();
                break;
            case "PROGRAM":
                autoComplete.load(searchForm, programsSearchList, {
                    autofocus: false,
                    searchClass: ".nav-search",
                    submitOnSelect: true,
                    selectedIdentifierClass: ".selected-program",
                    minLength: 0,
                    item: {
                        identifier: item => item.code,
                        label: item => item.label,
                        search: item => item.label,
                        selectedLabel: item => item.label
                    }});
                prevSearchName !== "" ? $("#selected-program").val(prevSearchId) : "";
                $("#search-button").hide();
                autofocus = true;
                break;
            case "AWARD":
                autoComplete.load(searchForm, awardsSearchList, {
                    autofocus: false,
                    searchClass: ".nav-search",
                    submitOnSelect: true,
                    selectedIdentifierClass: ".selected-award",
                    minLength: 0,
                    item: {
                        identifier: item => item.code,
                        label: item => item.label,
                        search: item => item.label,
                        selectedLabel: item => item.label
                    }});
                prevSearchName !== "" ? $("#selected-award").val(prevSearchId) : "";
                $("#search-button").hide();
                autofocus = true;
                break;
        }

        if (autofocus) {
            $("#nav-search").off("focus.autofocus").on("focus.autofocus", function () {
                $(this).autocomplete("search");
            });
            if (!onload) {
                $("#nav-search").trigger("focus");
            }
        }
    }
});

console.debug("Loaded library: search-bar");
